import { NtIdEmployee } from '../types/ntIdManagement.types';

type Props = {
  open: boolean;
  deleting?: boolean;
  employee: NtIdEmployee | null;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteConfirmationModal = ({
  open,
  deleting = false,
  employee,
  onClose,
  onConfirm,
}: Props) => {

  if (!open || !employee) {

    return null;

  }

  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-6">

      <div className="w-full max-w-md rounded-2xl bg-white shadow-xl">

        <div className="flex justify-center pt-8">

          <div
            className="
              flex
              h-16
              w-16
              items-center
              justify-center
              rounded-full
              bg-red-100
            "
          >

            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#DC2626"
              strokeWidth="2"
            >
              <path d="M3 6h18" />

              <path d="M8 6V4h8v2" />

              <path d="M19 6l-1 14H6L5 6" />

              <path d="M10 11v6" />

              <path d="M14 11v6" />

            </svg>

          </div>

        </div>

        <div className="px-8 py-6 text-center">

          <h2 className="text-xl font-semibold text-[#231F16]">

            Delete Employee

          </h2>

          <p className="mt-4 text-sm leading-6 text-[#7A7468]">

            Are you sure you want to delete

            <span className="font-semibold text-[#231F16]">

              {' '}
              {employee.employeeName}

            </span>

            ?

          </p>

          <p className="mt-2 text-sm text-[#7A7468]">

            Employee Code:

            <span className="ml-1 font-medium text-[#231F16]">

              {employee.employeeCode}

            </span>

          </p>

          <p className="mt-5 text-sm text-red-600">

            This action cannot be undone.

          </p>

        </div>

        <div className="flex justify-end gap-3 border-t border-[#ECE8DE] px-6 py-5">

          <button
            type="button"
            onClick={onClose}
            disabled={deleting}
            className="
              rounded-lg
              border
              border-[#DDD7CA]
              px-5
              py-2
              font-medium
              transition
              hover:bg-[#F7F5EF]
            "
          >

            Cancel

          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={deleting}
            className="
              rounded-lg
              bg-red-600
              px-5
              py-2
              font-medium
              text-white
              transition
              hover:bg-red-700
              disabled:opacity-60
            "
          >

            {deleting
              ? 'Deleting...'
              : 'Delete'}

          </button>

        </div>

      </div>

    </div>

  );

};

export default DeleteConfirmationModal;